import QuantityDesktop from '../../../../../components/buybox/quantity/quantity.desktop';
import quantity from './quantity';

const configuredQuantity = quantity(QuantityDesktop);
export default configuredQuantity;
